/* eslint-disable max-len */
import { Grid } from '@mui/material';
import React, { memo } from 'react';
import CommentButton from './CommentButton';
import LikeButton from './LikeButton';
import RepostButton from './RepostButton';
import ShareButton from './ShareButton';
import useGetFeedPermissions from '../../../CustomHooks/useGetFeedPermissions';
import { useSelector } from 'react-redux';

const FeedFooter = (props) =>
{
	const { feed, feedId, requestT, delCloseGetApi, from, isVideoPlaying } = props;
	const isSchedule = feed?.scheduledAt;
	const isProfileType = [ 'network_profile', 'business_profile', 'my_profile', 'connection' ].includes(from);
	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions(feed, userData);

	const hasCommentPermission = getPermission('comments');
	const hasLikePermisssion = getPermission('likes');
	const shareAccess = [ 'poll' ].includes(feed?.feedType) || !getPermission('share');
	const repostAccess = feed?.repostObj?.feedId || [ 'occasion', 'poll' ].includes(feed?.feedType) || !getPermission('repost');

	return (
		<>
			{feed?.isActive !== false && requestT?.type !== 'draft' && (
				<Grid container direction='row' alignItems='center' justifyContent='space-between' py='16px'>
					<Grid item display='flex' flexDirection='row' gap={5} alignItems='center' pl='var(--pixel10)' className={`${isProfileType && 'disableMode'}`}>
						{!isSchedule && (
							<>
								{hasLikePermisssion && <LikeButton isLiked={feed?.selfLike} feedId={feedId} feed={feed} />}
								{hasCommentPermission && <CommentButton key={feed?.commentsCount} feed={feed} />}
								{!shareAccess && <ShareButton feed={feed} feedId={feedId} />}
								{!repostAccess && <RepostButton feed={feed} delCloseGetApi={delCloseGetApi} />}
								{/* Dynamically attach the ReadDescriptionButton */}
							</>
						)}
						{/* Placeholder for dynamically attaching the ReadDescriptionButton */}
						{requestT === 'fullscreen'
							?	<span className={`${isVideoPlaying && 'disableMode'}`} id={`feed_description_button_full_screen_${feed?._id}`} />
							:	<span id={`feed_description_button_${feed?._id}`} />
						}
					</Grid>
				</Grid>
			)}
		</>
	);
};

export default memo(FeedFooter);